// Suggestions for "Who holds your mortgage?". Homeowners can type any other name.
export const LENDERS = [
	"RBC Royal Bank",
	"TD",
	"Scotiabank",
	"BMO",
	"CIBC",
	"National Bank",
	"Desjardins",
	"Tangerine",
	"Simplii Financial",
	"HSBC",
	"Laurentian Bank",
	"ATB Financial",
	"Manulife Bank",
	"MCAP",
	"First National",
	"Equitable Bank",
	"Home Trust",
	"CMLS",
	"RFA",
	"Strive",
	"B2B Bank",
	"Meridian Credit Union",
	"Vancity",
	"Coast Capital",
	"Servus Credit Union",
	"Alterna",
	"Another credit union",
	"Private lender",
];
